import dynamic from 'next/dynamic';
import { useState } from 'react';

const TemplateVideo = dynamic(() => import('../template/TemplateVideo'));

const ResourceWatch = ({ posts, mainVideo, width, data }) => {
  const [hideTitle, setHideTitle] = useState(false);
  const title = data?.template_media_block_type?.field_title[0]?.value;

  return (
    <div className={'resource-watch'}>
      <div className={'inner-container'}>
        <span className={'page-sub'}>{title}</span>
        <hr />
        <div className={'watch-container'}>
          <TemplateVideo playOnTitleClick={true} width={width} hideTitle={true}>
            {data?.template_media_block_type}
          </TemplateVideo>
        </div>
      </div>
    </div>
  );
};

export default ResourceWatch;
